import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { Globals } from 'src/app/globals/globals';

@Injectable({
  providedIn: 'root'
})
export class KnowledgebaseService {

  constructor(public http: HttpClient, public globals: Globals) { }

  public createKnowledgeBase(data: any): Observable<any> {
    return this.http.post(environment.serviceurl + '/KnowledgeBase', data,);
  }

  public getKnowledgeBase(data: any): Observable<any> {
    return this.http.post(environment.serviceurl + '/KnowledgeBase/search', data,);
  }

  public getKnowledgeBaseById(id: any): Observable<any> {
    return this.http.get(environment.serviceurl + '/KnowledgeBase/' + id,);
  }

  public getKnowledgeBaseJsonDropdown(): Observable<any> {
    return this.http.get(environment.serviceurl + '/KnowledgeBaseData');
  }
  public getKnowledgeBaseJsonEmbedding(): Observable<any> {
    return this.http.get(environment.serviceurl + '/KnowledgeBaseData/ListEmbeddingModels');
  }



  public deletekb(id: string): Observable<any> {
    return this.http.delete(environment.serviceurl + '/KnowledgeBase/' + id,);
  }

  public getDataKnowledgeBase(data: any): Observable<any> {
    return this.http.post(environment.serviceurl + '/KnowledgeBaseData/search', data,);
  }
  public postDataKnowledgeBase(data: any): Observable<any> {
    let par: HttpParams = new HttpParams().set("multiPartData", "1");
    return this.http.post(environment.serviceurl + '/KnowledgeBaseData', data, { params: par });
  }

  public postDataKnowledgeBaseConfig(data: any): Observable<any> {
    return this.http.post(environment.serviceurl + '/KnowledgeBaseData/UpdateKnowledgeBaseData', data);
  }

  public deletekbData(id: string): Observable<any> {
    return this.http.delete(environment.serviceurl + '/KnowledgeBaseData/' + id,);
  }

  public getKnowledgeBaseDataById(id: any): Observable<any> {
    return this.http.get(environment.serviceurl + '/KnowledgeBaseData/' + id,);
  }

  public getPredefinedConfiguration(data): Observable<any> {
    return this.http.post(environment.serviceurl + '/PreDefinedConfig/GetPredefinedConfiguration', data);
  }

  public getDigestKnowledgeBaseData(data): Observable<any> {
    let par: HttpParams = new HttpParams().set("multiPartData", "1");
    return this.http.post(environment.serviceurl + '/KnowledgeBaseData/DigestKnowledgeBaseData', data, { params: par });
  }

  public getDeleteDocument(data): Observable<any> {
    let par: HttpParams = new HttpParams().set("multiPartData", "1");
    return this.http.post(environment.serviceurl + '/KnowledgeBaseData/DeleteDocument', data, { params: par });
  }
}
